import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Locations from "./pages/Locations";
import LocationDetail from "./pages/LocationDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Faq from "./pages/Faq";
import Reviews from "./pages/Reviews";
import Review from "./pages/Review";
import Contact from "./pages/Contact";
import Schedule from "./pages/Schedule";
import Financing from "./pages/Financing";
import Warranty from "./pages/Warranty";
import { Privacy, Terms } from "./pages/Legal";
import SitemapPage from "./pages/SitemapPage";
import Leads from "./pages/Leads";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/service-areas" element={<Locations />} />
          <Route path="/service-areas/:slug" element={<LocationDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/review" element={<Review />} />
          <Route path="/leave-a-review" element={<Navigate to="/review" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
          <Route path="/schedule-appointment" element={<Schedule />} />
          <Route path="/financing" element={<Financing />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Toaster theme="dark" position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}
